import { useState } from "react";
import { motion } from "framer-motion";
import { Menu, Phone, X } from "lucide-react";
import { Logo } from "@/components/Logo";
import { BUSINESS } from "@/constants/business";

const LINKS = [
    { label: "Services", href: "/#services" },
    { label: "How It Works", href: "/#how-it-works" },
    { label: "Coverage", href: "/#coverage" },
    { label: "Reviews", href: "/#reviews" },
];

export default function Navbar() {
    const [open, setOpen] = useState(false);
    return (
        <header
            data-testid="site-header"
            className="sticky top-0 z-50 backdrop-blur-2xl bg-[#0B0C0E]/85 border-b border-white/10"
        >
            <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between gap-6">
                <a href="/#top" data-testid="nav-brand-link" className="flex items-center gap-3 shrink-0">
                    <Logo />
                    <span className="font-display font-extrabold text-lg tracking-wide uppercase leading-none text-white">
                        Masons
                        <span className="block text-[10px] tracking-[0.35em] text-amber-500 font-mono font-medium">
                            Automotive
                        </span>
                    </span>
                </a>
                <nav className="hidden lg:flex items-center gap-8" data-testid="nav-links">
                    {LINKS.map((l) => (
                        <a
                            key={l.label}
                            href={l.href}
                            data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                            className="text-xs font-mono uppercase tracking-[0.2em] text-zinc-400 hover:text-amber-400 transition-colors duration-200"
                        >
                            {l.label}
                        </a>
                    ))}
                </nav>
                <div className="hidden md:flex items-center gap-3">
                    <a
                        href={BUSINESS.phoneTel}
                        data-testid="nav-call-dispatch-button"
                        className="flex items-center gap-2 text-xs font-mono text-zinc-300 border border-[#383E4C] rounded-full px-4 py-2 hover:border-amber-500/60 hover:text-amber-400 transition-colors duration-200"
                    >
                        <Phone className="w-3.5 h-3.5" /> {BUSINESS.phoneDisplay}
                    </a>
                    <motion.a
                        href="/#booking"
                        data-testid="nav-book-now-button"
                        whileHover={{ scale: 1.03 }}
                        whileTap={{ scale: 0.97 }}
                        className="bg-amber-500 text-[#0B0C0E] text-xs font-bold uppercase tracking-widest rounded-full px-5 py-2.5 hover:bg-amber-400 transition-colors duration-200"
                    >
                        Book Mechanic
                    </motion.a>
                </div>
                <button
                    data-testid="nav-mobile-menu-button"
                    onClick={() => setOpen(!open)}
                    className="lg:hidden text-zinc-300 p-2"
                    aria-label="Toggle menu"
                >
                    {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
                </button>
            </div>
            {open && (
                <div className="lg:hidden border-t border-white/10 bg-[#0B0C0E]/95 backdrop-blur-xl px-6 py-4 flex flex-col gap-4" data-testid="nav-mobile-menu">
                    {LINKS.map((l) => (
                        <a
                            key={l.label}
                            href={l.href}
                            onClick={() => setOpen(false)}
                            data-testid={`nav-mobile-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                            className="text-sm font-mono uppercase tracking-[0.2em] text-zinc-300"
                        >
                            {l.label}
                        </a>
                    ))}
                    <a
                        href="/#booking"
                        onClick={() => setOpen(false)}
                        data-testid="nav-mobile-book-button"
                        className="bg-amber-500 text-[#0B0C0E] text-xs font-bold uppercase tracking-widest rounded-full px-5 py-3 text-center"
                    >
                        Book Mechanic
                    </a>
                </div>
            )}
        </header>
    );
}
